import { createRouter, createRoute, AnyRoute } from '@tanstack/react-router';

import config from '@/config';
import { basepath } from '@/constants';

import { IssueView } from '@/views/issue/Issue';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';
import Drafts from '@/views/drafts/Drafts';
import { NotFound } from '@/views/RootRoute';

import { Callback, callbackSearchSchema } from './Callback';

import { rootRoute } from './Route';

import { route as indexRoute } from './home/Home';

/* Routes declaration */

const callbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Callback,
	validateSearch: callbackSearchSchema,
	path: 'callback',
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: IssueView,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: IssueView,
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Drafts,
	path: 'drafts',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	callbackRoute,
	issueRoute,
	issueArticleRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});
